export const DEFAULT_GRAPH_SEARCH_SETTINGS: Readonly<GraphSearchSettings> = {
  maxResults: 50,
  maxPaths: 20,
  stopOn: ["lateral"] as const,
} as const;

export const DISCOVER_ONLY_DEFAULT_SETTINGS: GraphSearchSettings = {
  maxResults: Infinity,
  maxPaths: 1,
  stopOn: ["lateral"],
};

export type GraphSearchSettings = {
  /** Maximum number of matching source nodes that can be returned */
  maxResults: number | null;
  /** Maximum number of paths returned per matching source node */
  maxPaths: number | null;
  /** Node types beyond which searches do not propagate */
  stopOn: Readonly<string[]>;
};
